/**
 * Représente un élément du menu contextuel des templates de mail.
 */
export class TemplateContextMenuItem {
	/**
	 * Constructeur.
	 * @param menuText : Texte de l'élément du menu.
	 * @param variable : Variable à insérer.
	 * @param source : Source du menu contextuel (Composant pour lequel le menu contextuel a été affiché).
	 */
	constructor(
		public menuText: string,
		public variable: string,
		public source: string
	) {}
}
